var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcseStarterIconColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#7734D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 21.1252L31.3333 29.8752C31.3333 30.6806 30.6803 31.3335 29.8749 31.3335H21.1249C20.3195 31.3335 19.6666 30.6806 19.6666 29.8752L19.6666 21.1252C19.6666 20.3197 20.3195 19.6668 21.1249 19.6668H29.8749C30.6803 19.6668 31.3333 20.3197 31.3333 21.1252Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6666 13.8335C16.4449 13.8335 13.8333 16.4452 13.8333 19.6668V31.3335C13.8333 34.5552 16.4449 37.1668 19.6666 37.1668H31.3333C34.5549 37.1668 37.1666 34.5552 37.1666 31.3335V19.6668C37.1666 16.4452 34.5549 13.8335 31.3333 13.8335H19.6666ZM34.2499 29.8752V21.1252C34.2499 18.7089 32.2912 16.7502 29.8749 16.7502L21.1249 16.7502C18.7087 16.7502 16.7499 18.7089 16.7499 21.1252L16.7499 29.8752C16.7499 32.2914 18.7087 34.2502 21.1249 34.2502H29.8749C32.2912 34.2502 34.2499 32.2914 34.2499 29.8752Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9166 29.8752C10.9166 28.2643 12.2225 26.9585 13.8333 26.9585H21.125C22.7358 26.9585 24.0416 28.2643 24.0416 29.8752V37.1668C24.0416 38.7777 22.7358 40.0835 21.125 40.0835H13.8333C12.2225 40.0835 10.9166 38.7777 10.9166 37.1668V29.8752Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9583 13.8334C26.9583 12.2226 28.2641 10.9167 29.8749 10.9167H37.1666C38.7774 10.9167 40.0833 12.2226 40.0833 13.8334V21.1251C40.0833 22.7359 38.7774 24.0417 37.1666 24.0417H29.8749C28.2641 24.0417 26.9583 22.7359 26.9583 21.1251V13.8334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcseStarterIconColour);
export default __webpack_public_path__ + "static/media/GCSEStarterIconColour.8480a53b745d8a9fd984c83305671684.svg";
export { ForwardRef as ReactComponent };